import { Outlet } from 'react-router-dom';
import { useAuth } from '@/shared/hooks/useAuth';
import { AuthLoading } from './AuthLoading';

/**
 * The customer app (inbox, composer, onboarding…). Staff (super admins) use
 * it like any customer, with their own brands, and reach the admin console
 * from the sidebar's Admin item; the console keeps its own guard.
 */
export function CustomerOnlyGuard() {
  const { isLoading } = useAuth();
  if (isLoading) return <AuthLoading />;
  return <Outlet />;
}
